import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Row, Col, Button } from 'react-bootstrap';
import appConstant from '../../../constants/app';

class DeleteSectionForm extends PureComponent {
  static propTypes = {
    sectionId: PropTypes.number,
    label: PropTypes.string,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
  };

  state = {
    sectionId: null,
  }

  sectionDelete = () => {
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/section/destroy?access_token=${localStorage.getItem('token')}`, 
      data: {
        id: this.props.sectionId,
      },
    }).then(res => {
      this.props.onClose();
      this.props.onAccept();
    }).catch(err => {
      console.log(err);
    });
  }

  render () {
    const {
      label,
    } = this.props;

    return (
      <div className="confirmation-modal-body">
        <Row>
          <Col sm={12}>
            <p className="modal-paragraph">
              If you delete {label}, you will lose all related information.
            </p>
          </Col>
        </Row>
        <Row className="confirmation-btns-footer">
          <Col sm={12}>
            <Button
              onClick={this.props.onClose}
              className="cancel-btn"
            >
              Cancel
            </Button>
            <Button
              onClick={this.sectionDelete}
              className="accept-btn"
            >
              Accept
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DeleteSectionForm;


// WEBPACK FOOTER //
// ./src/app/screens/sections/deleteSectionForm.js